var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.773,
    height: 14.941,
    viewBox: "0 0 13.773 14.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.277,11.554h0a.344.344,0,0,0,.1.075.187.187,0,0,0,.125.025h0a.3.3,0,0,0,.224-.1h0l4.183-4.184h0a.3.3,0,0,0-.423-.423L16.8,10.633V.3a.3.3,0,0,0-.6,0V10.633L12.542,6.948a.3.3,0,0,0-.423.423Z",
    transform: "translate(-7.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.8,44.7a.288.288,0,0,0-.3.3v2.914H2.9V45a.3.3,0,1,0-.6,0v3.212a.288.288,0,0,0,.3.3H15.772a.288.288,0,0,0,.3-.3V45A.269.269,0,0,0,15.8,44.7Z",
    transform: "translate(0 -33.569)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.a8ee64d8a72b861f79328d944a3252ef.svg";
export { ForwardRef as ReactComponent };